import { Loader } from "lucide-react";
import { GroupAvatar, StatusDot } from "./BroadcastAtoms";
import { formatDate } from "./constants";

const GroupListItem = ({ group, lastBroadcast, isSelected, onClick }) => {
  const isSending    = lastBroadcast?.status === "sending";
  const contactCount = group.activeCustomerCount ?? group.customerCount ?? 0;

  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 transition-colors text-left border-b border-gray-100
        ${isSelected ? "bg-blue-50 border-l-2 border-l-blue-500" : "hover:bg-gray-50"}`}
    >
      <GroupAvatar group={group} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <p className="text-sm font-semibold text-gray-900 truncate">{group.name}</p>
          <span className="text-[11px] text-gray-400 flex-shrink-0">
            {lastBroadcast ? formatDate(lastBroadcast.createdAt) : ""}
          </span>
        </div>
        <div className="flex items-center justify-between gap-2 mt-0.5">
          <div className="flex items-center gap-1.5 min-w-0">
            {lastBroadcast ? (
              <>
                <StatusDot status={lastBroadcast.status} />
                <p className="text-xs text-gray-500 truncate">
                  {lastBroadcast.name || lastBroadcast.template?.templateName || "Broadcast"}
                </p>
              </>
            ) : (
              <p className="text-xs text-gray-400 italic">No broadcasts yet</p>
            )}
          </div>
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {isSending && <Loader className="w-3 h-3 text-blue-500 animate-spin" />}
            {contactCount > 0 && (
              <span className="text-[10px] text-gray-400">
                {contactCount > 999 ? "999+" : contactCount} contacts
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};

export default GroupListItem;
